<template>
	<v-layout column fill-height v-cloak class="preview-proposal">
		<v-flex class="flex-column">
			<v-card-title class="px-0 flex-column__row">
				<h3 class="subheading font-weight-bold secondary--text mb-1">
					{{ document.name }} |
					{{ document.proposal_date | moment("MMM D YYYY") }}
				</h3>
				<v-spacer></v-spacer>
				<proposal-actions :document="document"></proposal-actions>
			</v-card-title>

			<v-layout row class="flex-column__row--full">
				<v-flex sm12 class="flex-column">
					<v-card class="fill-height scroll-card">
						<v-layout :fill-height="fillHeight" wrap>
							<v-flex
								fill-height
								class="flex-column preview-proposal__left"
							>
								<v-card-title class="pt-0 flex-column__row">
									<h3
										class="subheading font-weight-bold secondary--text"
									>
										Quote #{{ document.number }}
									</h3>
								</v-card-title>
								<v-layout
									fill-height
									class="mt-0 flex-column__row flex-column__row--full preview-proposal__inner"
								>
									<v-flex
										class="py-0 preview-proposal__quote-actions"
									>
										<proposal-actions
											:document="document"
											:list="true"
										></proposal-actions>
									</v-flex>
									<v-flex
										class="py-0 preview-proposal__quote"
									>
										<div
											class="quote-builder__card-inner inner-scroll"
										>
											<v-card-text
												class="pa-0 inner-scroll__scroller proposal-border proposal-border--no-mar"
											>
												<v-card
													class="scroll-card fill-height"
													color="lightbg"
													flat
												>
													<v-card-text class="py-0">
														<proposal-header
															:document="document"
														></proposal-header>
													</v-card-text>

													<v-card-text class="pb-0">
														<proposal-table
															:document="document"
														></proposal-table>
													</v-card-text>

													<v-divider
														class="ma-3"
														v-if="document.messages"
													></v-divider>

													<v-card-text
														class="py-0"
														v-if="document.messages"
													>
														<div
															class="preview-proposal__messages"
														>
															<h4
																class="body-1 font-weight-bold"
															>
																Notes:
															</h4>
															<p>
																{{
																	document.messages
																}}
															</p>
														</div>
													</v-card-text>
												</v-card>
											</v-card-text>
										</div>
									</v-flex>
								</v-layout>
							</v-flex>

							<v-flex class="preview-proposal__right">
								<div
									class="quote-builder__card-inner inner-scroll"
								>
									<v-card-title class="pt-0">
										<h3
											class="subheading font-weight-bold secondary--text"
										>
											Order
										</h3>
									</v-card-title>

									<v-card-text
										class="py-0 inner-scroll__scroller"
									>
										<v-text-field
											v-model="po_number"
											label="Purchase Order #"
											outline
											flat
											@blur="save('po_number', po_number)"
											:disabled="disabled"
										></v-text-field>


										<v-textarea
											v-model="notes"
											label="Shipping or Special Instructions"
											outline
											name="proposal_notes"
											flat
											@blur="save('notes', notes)"
											:disabled="disabled"
										></v-textarea>
									</v-card-text>

									<v-card-actions class="pt-3 justify-center">
										<v-btn
											@click="orderNow"
											color="success"
											large
											:loading="loading"
											>Order Now</v-btn
										>
									</v-card-actions>
									<v-card-text>
										<table
											width="100%"
											class="order-by-table"
										>
											<tr
												v-for="{
													title,
													phone
												} of phoneNumbers"
												:key="phone"
											>
												<td>{{ title }}</td>
												<td class="text-xs-right">
													{{ phone }}
												</td>
											</tr>

											<tr
												v-if="
													currentTeam.team_settings
														.order_email
												"
											>
												<td>Order by Email</td>
												<td class="text-xs-right">
													<a
														:href="
															`mailto:${
																currentTeam
																	.team_settings
																	.order_email
															}`
														"
														>{{
															currentTeam
																.team_settings
																.order_email
														}}</a
													>
												</td>
											</tr>
										</table>
									</v-card-text>
								</div>
							</v-flex>
						</v-layout>
					</v-card>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import ProposalHeader from "@components/partials/ProposalHeader";
import ProposalTable from "@components/partials/ProposalTable";
import ProposalActions from "@components/partials/ProposalActions";
import ProposalNotesMessages from "@components/partials/ProposalNotesMessages";
var { mainRoutes } = require("@root/mixins");

export default {
	mixins: [mainRoutes],

	data() {
		return {
			po_number: "",
			notes: "",
			disabled: false,
			loading: false
		};
	},

	components: {
		ProposalActions,
		ProposalTable,
		ProposalNotesMessages,
		ProposalHeader
	},

	computed: {
		...mapGetters(["privacy", "currentTeam"]),

		// fillHeight() {
		// 	console.log(this.$router);

		// 	if (this.$vuetify.breakpoint.lgAndDown) {
		// 		return false;
		// 	}

		// 	return true;
		// }

		phoneNumbers() {
			const numbersMap = {};

			for (const { part } of this.document.line_items) {
				const categorySlug = part.part_family.slug;

				if (categorySlug === "nutting-carts-trailers") {
					numbersMap.nutting = {
						title: "Order Nutting by Phone",
						phone: "1-800-533-0337"
					};
				} else {
					numbersMap.other = {
						title: "Order by Phone",
						phone: "1-800-967-7333"
					};
				}
			}

			return Object.values(numbersMap);
		}
	},

	methods: {
		...mapActions("documents", {
			ORDER_DOCUMENT: "orderDocument",
			UPDATE_DOCUMENT_FIELD: "updateDocumentField"
		}),

		...mapMutations("documents", {
			UPDATE_DOCUMENT_FIELDS: "updateDocumentFields"
		}),

		save(field, value) {
			if (this.document.ordered_at) {
				return;
			}

			if (value != this.document[field]) {
				let params = {};
				params[field] = value;

				return this.UPDATE_DOCUMENT_FIELD({
					document_number: this.number,
					field,
					params
				});
			}
		},

		orderNow() {
			this.loading = true;

			this.$swal({
				title: "Are you sure?",
				text: "This cannot be undone.",
				type: "warning",
				showCancelButton: true,
				confirmButtonText: "Order Now"
			}).then(result => {
				console.log(result,"result");
				if (result.value) {
					console.log(this.document,"order")
					this.ORDER_DOCUMENT({
						document: this.document
					}).then(data => {
						if(data.document == "material_number"){
							this.$swal({
								title: "Error Occured!",
								text:"Please update material number in part",
								type: "error",
								confirmButtonText: "Ok"
							}).then(result=>{
								window.location.reload();
							});
						}
						if(data.document.error=="true"){
							this.$swal({
								title: "Error Occured!",
								text:data.document.errormsg,
								type: "error",
								confirmButtonText: "Ok"
							}).then(result=>{
								window.location.reload();
							});
						}
						this.UPDATE_DOCUMENT_FIELDS({
							id: data.document.id,
							ordered_at: data.document.ordered_at
						});

						this.$swal({
							title: "Order Sent",
							text:
								"Thank you for your order, some one will be in contact with you shortly.",
							type: "success",
							showCancelButton: false,
							confirmButtonText: "Okay"
						}).then(result => {
							this.nextStep(6);
							window.location.reload();
							console.log(result,"result");
						});
					}).catch(error=>{console.log(error)});
				} else {
					this.loading = false;

					return;
				}
			});
			return;
		}
	},

	created() {
		this.notes = this.document.notes;
		this.po_number = this.document.po_number;
	}
};
</script>
